import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import CreditKeyBanner from "../CreditKey/CreditKeyBanner";
import DivideByUnitPrice from "./DivideByUnitPrice";
interface Props {
  price: number;
  unitOfMeasure: string;
  divideByUnit?: string;
  divideQuantity?: number;
  showCreditKey?: boolean;
  priceCrossedOut?: boolean;
  divideByUnitCssClass?: string;
}
const StandardPrice = ({
  price,
  unitOfMeasure,
  divideByUnit,
  divideQuantity,
  showCreditKey = true,
  priceCrossedOut = false,
  divideByUnitCssClass
}: Props) => {
  const renderDivideByUnitPrice = () => {
    if (!divideByUnit || divideByUnit?.length === 0) {
      return <></>;
    }
    if (!divideQuantity || divideQuantity <= 0) {
      return <></>;
    }
    return <DivideByUnitPrice divideByUnit={divideByUnit} divideQuantity={divideQuantity} price={price} cssClass={divideByUnitCssClass || "text-xs block"} data-sentry-element="DivideByUnitPrice" data-sentry-component="renderDivideByUnitPrice" data-sentry-source-file="StandardPrice.tsx" />;
  };
  return <>
      <p className="leading-none mb-0" data-testid="price-container">
        <span className={`price ${priceCrossedOut ? "strikeOutPrice" : ""} `}>
          {formatAsCurrency.formatIfUndefined(price)}
          {unitOfMeasure && <span className="each pr-1">{`/${unitOfMeasure}`}</span>}
        </span>
        {renderDivideByUnitPrice()}
      </p>
      {showCreditKey && !priceCrossedOut && <CreditKeyBanner price={price} />}
    </>;
};
export default StandardPrice;